import { useEffect, useState } from "react";
import { apiV1 } from "@/lib/api";

/**
 * Server-time clock. Polls /api/v1/health every minute to detect clock
 * drift between client and server. In the header it shows the server's
 * own UTC time so you trust the same wall-clock as the logs.
 */
export function useClock() {
  const [now, setNow] = useState<Date>(new Date());

  // Server-time anchor — periodically reconcile to server's clock.
  useEffect(() => {
    let offsetMs = 0;
    let alive = true;

    const sync = async () => {
      try {
        const r = await apiV1.health();
        const serverNow = new Date(r.time).getTime();
        offsetMs = serverNow - Date.now();
      } catch {
        // keep last offset; tick continues from local clock
      }
      if (alive) setNow(new Date(Date.now() + offsetMs));
    };
    sync();
    const syncId = window.setInterval(sync, 60_000);

    const tickId = window.setInterval(() => {
      if (alive) setNow(new Date(Date.now() + offsetMs));
    }, 1000);

    return () => {
      alive = false;
      window.clearInterval(syncId);
      window.clearInterval(tickId);
    };
  }, []);

  return now;
}
